var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[(_vm.mapReady)?_c('ClientOnly',[_c('yandex-map',{attrs:{"settings":_vm.settings,"coords":_vm.coords,"zoom":"14"}},[_c('ymap-marker',{attrs:{"marker-id":"0","coords":_vm.coords,"icon":_vm.icon}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }